import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["appearance", "isHidden", "children"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { Anchor } from '../Anchor/Anchor';
import IconChevronDown from '../Icon/icons/IconChevronDown';
import IconChevronUp from '../Icon/icons/IconChevronUp';
import { TextButton } from '../TextButton/TextButton';

/**
 * `ShowHideButton` is the default button used by the `ShowHide` component.
 *
 * @extends TextButton
 * @since 8.36.0
 */
export var ShowHideButton = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    isHidden = _ref.isHidden,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (appearance === 'inline') {
    return /*#__PURE__*/React.createElement(Anchor, _extends({
      as: "button",
      ref: forwardedRef,
      "aria-expanded": !isHidden
    }, rest), children);
  }
  var icon = /*#__PURE__*/React.createElement(IconChevronUp, null);
  if (isHidden) {
    icon = /*#__PURE__*/React.createElement(IconChevronDown, null);
  }
  return /*#__PURE__*/React.createElement(TextButton, _extends({
    ref: forwardedRef,
    icon: icon,
    "aria-expanded": !isHidden,
    iconSize: "xs"
  }, rest), children);
});
ShowHideButton.displayName = 'ShowHideButton';
ShowHideButton.propTypes = process.env.NODE_ENV !== "production" ? {
  appearance: PropTypes.oneOf(['inline', 'block']).isRequired,
  isHidden: PropTypes.bool,
  children: PropTypes.node
} : {};